import { render, staticRenderFns } from "./DowntimeService.vue?vue&type=template&id=3fee933c&"
import script from "./DowntimeService.vue?vue&type=script&lang=js&"
export * from "./DowntimeService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports